import { Box, Button, Text, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea, HStack } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import LogosNotification from "utils/notification-utils";
import ProgramService from "../../../../services/programs/program-service";

interface AddLessonGroupDialogProps {
    program: any,
    lessonGroupId: string,
    lesson: any,
    onClose: any
};

const formInitialValue = {
    newLessonGroupId: ''
};

const MoveLessonGroupDialog: FC<AddLessonGroupDialogProps> = ({ program, lessonGroupId, lesson, onClose }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [lessonGroup, setLessonGroup] = useState<any>(null);
    const [lessonGroups, setLessonGroups] = useState<any[]>([]);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    useEffect(() => {
        var lessonGroup = program.lessonGroups.find((i: any) => i.id == lessonGroupId);
        setLessonGroup(lessonGroup);

        var listLessonGroups = program.lessonGroups.filter((i: any) => i.id != lessonGroupId);
        setLessonGroups(listLessonGroups);
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ProgramService.MoveLessonGroup(program.id, lessonGroupId, lesson.id, values.newLessonGroupId).then((res: any) => {
            LogosNotification.Success("Lesson Group berhasil diperbaharui.");
            onClose();
            window.location.reload();
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                    {
                        ({ handleSubmit, errors, touched, setFieldValue }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Pindah Lesson Group</ModalHeader>
                                <ModalBody pt={5}>

                                    <Box pt={0} pb={4}>
                                        <HStack>
                                            <Text fontSize={'sm'} color={'gray.500'}>Group Sekarang: </Text>
                                            <Text fontSize={'sm'} fontWeight={'bold'}>{lessonGroup.title}</Text>
                                        </HStack>
                                    </Box>

                                    <FormControl isRequired mt={4}>
                                        <FormLabel htmlFor='newLessonGroupId'>Group Baru</FormLabel>
                                        <Field
                                            as={Select}
                                            id='newLessonGroupId'
                                            placeholder='Pilih Lesson Group'
                                            name={'newLessonGroupId'}
                                            validate={(value: any) => {
                                                let error;
                                                if (!value)
                                                    error = "Silahkan pilih Lesson Group";
                                                return error;
                                            }}
                                        >
                                            {
                                                lessonGroups.map((group: any) => {
                                                    return <option value={group.id}>{group.title}</option>
                                                })
                                            }
                                        </Field>
                                        <FormErrorMessage>{errors.newLessonGroupId}</FormErrorMessage>
                                    </FormControl>

                                </ModalBody>
                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Close
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Submit</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>
            </ModalContent>
        </Modal>
    );
};

export default MoveLessonGroupDialog;
